import React, { PureComponent } from 'react';
import { CachedImage, Image, View, Text } from 'core';
import { imageProcessor, CDN } from 'utils';
import { IMAGE_SIZE, css, theme } from 'constants';
import * as actions from 'actions';
import { IcoPlay } from 'icons';

const styles = css({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  progress: {
    position: 'absolute',
    color: 'white'
  },
  icon_container: {
    backgroundColor: theme.gray_color_alpha(0.5),
    width: 60,
    height: 60,
    borderRadius: 30,
    position: 'absolute'
  }
});

export class VideoMsg extends PureComponent {
  state = {};
  componentDidMount() {
    this.is_mounted = true;
    const { current_msg } = this.props;
    const { user_id, file_id, ext } = current_msg.data;
    CDN.getURL({ user_id, file_id, ext }, () => {}, this.updateProgress);
  }
  componentWillUnmount() {
    this.is_mounted = false;
  }
  updateProgress = downloadProgress => {
    const progress = CDN.getPercentage(downloadProgress);
    this.is_mounted &&
      this.setState({
        progress: progress === '%100' ? null : progress
      });
  };

  render() {
    const { current_msg } = this.props;
    const { progress } = this.state;
    const { width, height } = current_msg.data;
    const size = imageProcessor.getDimensions(width / height, IMAGE_SIZE.MEDIUM);
    const blobURL = actions.uploader.getBlobURI(current_msg.id + '_thumbnail');
    return (
      <View style={styles.container}>
        {blobURL ? <Image source={{ uri: blobURL }} style={size} /> : <CachedImage size={size} color={`#${current_msg.data.color}`} is_large upload={current_msg.data} />}
        {progress ? <Text style={styles.progress}>{progress}</Text> : null}
        {!progress ? (
          <View style={[styles.container, styles.icon_container]} onPress={() => {}}>
            <IcoPlay style={styles.play_icon} color="white" size={30} />
          </View>
        ) : null}
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/middle/chat/msgs/video.js